import { Button, type ButtonProps } from '@mantine/core'

import { useAnalytics } from '@flecto/analytics'
import { type ParameterID } from '@flecto/types'
import { Icon } from '@flecto/ui'

import {
  type BookingActionType,
  useBookingActions,
} from '../../../booking-actions'

export type ButtonActionProps = ButtonProps & {
  bookingId?: ParameterID
  actionKey: BookingActionType
}

export function ButtonAction({
  bookingId,
  actionKey,
  ...props
}: ButtonActionProps) {
  const track = useAnalytics('segment')
  const { getAction, hasCustomer, noHasCustomerNotification, bookingStatus } =
    useBookingActions({ bookingId })

  const action = getAction(actionKey)

  if (!action) {
    return null
  }

  return (
    <Button
      {...props}
      onClick={() => {
        if (
          !hasCustomer &&
          (actionKey === 'reserve' ||
            actionKey === 'pickup' ||
            actionKey === 'change_status_to_quoted' ||
            actionKey === 'create_quote')
        ) {
          noHasCustomerNotification()
        } else if (hasCustomer && actionKey === 'create_quote') {
          track('BOOKING_QUOTE__NEW', {
            bookingID: bookingId ?? '',
            bookingStatus: bookingStatus ?? '',
            clickedOn: 'booking-action-button',
          })
          action.action()
        } else {
          action.action()
        }
      }}
      leftSection={<Icon icon={action.icon} />}
    >
      {action.label}
    </Button>
  )
}
